import * as yup from 'yup';

const hasTenPhoneDigits = (value) => {
    if (!value) return false;
    return value.replace(/\D/g, '').length === 10;
};

export const validationSchema = yup.object({
    firstName: yup
        .string('First name')
        .required("First name is required"),
    lastName: yup
        .string('Last name')
        .required("Last name is required"),
    mobile: yup
        .string('Phone')
        .test('mobile-format', 'Please enter a valid phone number', (value) => {
            if (!value) return true;
            return hasTenPhoneDigits(value);
        })
        .required("At least one phone is required"),
    birthdate: yup
    .date(),
    sex: yup
    .string()
    ,
    addrCountry: yup
    .string()
    .oneOf(['Canada', 'USA'], 'Country must be Canada or United States')
});